import React, { useState } from "react";
import { KontentRichText } from "../../../types";
import { CustomRichTextElement } from "../../elements/CustomRichTextElement/CustomRichTextElement";
import { ExpandCollapseButton } from "../../elements/ExpandCollapseButton/ExpandCollapseButton";
import * as styles from "./Accordion.module.css";

export interface AccordionProps {
  label: string;
  contentCategory: string;
  text: KontentRichText;
}

export const Accordion: React.FC<AccordionProps> = ({
  label,
  text,
  contentCategory,
}) => {
  const [expanded, setExpanded] = useState(false);

  const handleFaqClick = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={styles.accordion}>
      <div className={styles.heading}>
        <ExpandCollapseButton handleClick={handleFaqClick} open={expanded}>
          <div>
            {contentCategory && (
              <div className={styles.category}>{contentCategory}</div>
            )}

            <h3>{label}</h3>
          </div>
        </ExpandCollapseButton>
      </div>
      <div
        className={
          expanded
            ? styles.textContainer + " " + styles.open
            : styles.textContainer
        }
      >
        <div className={styles.text}>
          <CustomRichTextElement content={text} />
        </div>
      </div>
    </div>
  );
};
